var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1L3 7.92957V21.7887L15 28.7183L27 21.7887V7.92957L15 1ZM25.9461 21.1822L15 27.5053L4.05386 21.1822V8.54598L15 2.22286L25.9461 8.54598V21.1822Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7026 6.98511H10.2677L9.17407 11.7971H20.836L19.7026 6.98511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9478 18.4087V15.2173L9.15411 13.4377L5.99255 15.784L10.2974 23.2803H12.0174L14.0555 21.3913V20.4369L11.9478 18.4087Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0622 12.5226H11.9578L12.9818 15.207L12.6736 18.2095H15L17.3463 18.1995L17.058 15.207L18.0622 12.5226Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8558 13.4178L18.092 15.2173V18.4087L15.9843 20.4369V21.3913L18.0124 23.2604H19.7125L24.0074 15.784L20.8558 13.4178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocom);
export default __webpack_public_path__ + "static/media/crypto.com.4e4cd35d63b42561ae3038938a58a0b0.svg";
export { ForwardRef as ReactComponent };